"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RatePlanTypeEnum;
(function (RatePlanTypeEnum) {
    RatePlanTypeEnum["ZUORA_PRODUCT_RATE_PLAN"] = "zuora_product_rate_plan";
    RatePlanTypeEnum["CIMA_ZUORA_PRODUCT_RATE_PLAN"] = "cima_zuora_product_rate_plan";
})(RatePlanTypeEnum = exports.RatePlanTypeEnum || (exports.RatePlanTypeEnum = {}));
var FLPTermEnum;
(function (FLPTermEnum) {
    FLPTermEnum["_12_MONTHS"] = "12";
    FLPTermEnum["_24_MONTHS"] = "24";
    FLPTermEnum["_36_MONTHS"] = "36";
})(FLPTermEnum = exports.FLPTermEnum || (exports.FLPTermEnum = {}));
exports.FLPTermBillingPeriodMap = {
    [FLPTermEnum._12_MONTHS]: 'Annual',
    [FLPTermEnum._24_MONTHS]: 'Two_Years',
    [FLPTermEnum._36_MONTHS]: 'Three_Years',
};
//# sourceMappingURL=product-membership.js.map